<template>
    <div>
        <div style="display: flex; justify-content: space-around">
            <div class="imgBox">
                <span class="imgTitle">手持正面照</span>
                <ImgView :src="identityForm.imgZ" size="600px"/>
            </div>
            <div class="imgBox">
                <span class="imgTitle">身份证正面照</span>
                <ImgView :src="identityForm.imgF" size="600px"/>
            </div>

        </div>
        <div style="display: flex;justify-content: center; margin: 24px 0;">
          <div style="border-right: 1px #ededed solid; width: 240px; padding-left: 32px">
            <HeadImg :images="identityForm.headImg" />
            <div style="margin-top: 16px;">
              <UserInfoList :row="identityForm" showList="name,phone,uid,city" :isDialog="true"/>
              <p>总状态：<span>{{identityForm.overallAuthState==0?'未提交':identityForm.overallAuthState==1?'待审核':identityForm.overallAuthState==2?'审核通过':identityForm.overallAuthState==3?'审核不通过':''}}</span></p>
            </div>
          </div>
          <div style="width: 500px; display: flex; flex-direction: column; align-items: center">
            <el-form ref="form" :model="identityForm" label-width="110px">
              <el-form-item label="实名：">
                <el-input v-model="identityForm.identityName" placeholder="输入实名" style="width: 20em"></el-input>
              </el-form-item>
              <el-form-item label="身份证号：">
                <el-input v-model="identityForm.identityCode" :maxlength="18" placeholder="输入身份证号" style="width: 20em"></el-input>
              </el-form-item>
              <el-form-item label="审核结果：">
                <el-radio-group v-model="isShow" >
                  <el-radio-button :label="1">通过 <i class="el-icon-check" v-show="isShow==1"></i></el-radio-button>
                  <el-radio-button :label="0">不通过 <i class="el-icon-check" v-show="isShow==0"></i></el-radio-button>
                </el-radio-group>
                <el-button type="warning" style="margin-left: 24px" @click="appointAuth()">指定身份认证</el-button>
              </el-form-item>
              <el-form-item label="身份认证类型：" v-show="isShow==1">
                <el-radio-group v-model="identityForm.type" class="ml-4">
                  <el-radio :label="1" size="large">身份证</el-radio>
                  <el-radio :label="2" size="large">非身份证</el-radio>
                  <el-radio :label="3" size="large">其它</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="不通过照片：" v-show="isShow==0">
                <div style="line-height: 20px;">
                  <el-checkbox-group v-model="checkList">
                    <div><el-checkbox :label="1">手持正面照</el-checkbox></div>
                    <div><el-checkbox :label="2">身份证正面照</el-checkbox></div>
                  </el-checkbox-group>
                  <div><el-checkbox v-model="regAgain">重复注册</el-checkbox></div>
                  <div><el-checkbox v-model="isNonage">未成年用户</el-checkbox></div>
                </div>
              </el-form-item>
              <el-form-item v-if="isNonage">
                <div style="color: red">* 该用户为未成年，请不予通过</div>
              </el-form-item>
            </el-form>
            <div class="dialog-footer" style="text-align: center;margin-bottom: 16px;">
              <el-button @click.native="cancel" >返回</el-button>
              <el-button type="primary" @click="identitySub" v-loading="identitySubLoading">提交</el-button>
            </div>
          </div>

        </div>

    </div>

</template>

<script>
    import ImgView from "@/views/auth/components/ImgView";
    import { postFormData, getFormData } from "../../../../api/api";
    import {updateIdentityState, getPlainInfo, updateCertifyState, updateResumeRecheckAuth} from "../../../../api/url";
    import Dialog from "@/assets/js/dialog";
    import AppointAuthDialog from "@/components/resume/AppointAuthDialog";

    export default {
        name: "IdentityExamine",
        components: { ImgView },
        props: {
            value: Object
        },
        data() {
            return {
                identityForm: this.value.identityForm,
                isNonage: this.value.identityForm.isNonage,
                isOperation: this.value.isOperation,
                isFast: this.value.isFast,
                isShow: this.value.identityForm.identityState >= 3?0:1, //通过1，不通过0
                checkList:this.value.isOperation?[]:[1,2],
                state: 1,
                regAgain: this.value.identityForm.isRepeat == 1 ? true : false,
                identitySubLoading: false,
            }
        },
        methods: {
            //返回
            cancel() {
                this.$emit('close');
            },
            //提交
            identitySub() {
                let reg = /(^\d{17}(\d|X|x)$)/;
                if(this.isShow == 0 && this.checkList.length == 0 && !this.isOperation){
                    this.$message({
                        showClose: true,
                        duration: 1500,
                        message: '请选择不通过照片',
                        type: 'warning'
                    })
                    return;
                }
                if(this.isShow == 0) {
                  if(this.checkList.length == 2 || (this.isOperation && this.checkList.length == 0 || this.isNonage)){
                    this.state = 3;
                  }else if(this.checkList[0] == 1){
                    this.state = 4;
                  }else if(this.checkList[0] == 2){
                    this.state = 5;
                  }
                }
                if(this.isShow == 1){
                    if(this.identityForm.identityName == null || this.identityForm.identityName == '' || this.identityForm.identityCode == null || this.identityForm.identityCode == ''){
                        this.$message({
                            showClose: true,
                            duration: 1500,
                            message: '实名与身份证号不能为空！',
                            type: 'warning'
                        })
                        return;
                    }else{
                        let bool = reg.test(this.identityForm.identityCode);
                        if(!bool) {
                            this.$message({
                                showClose: true,
                                duration: 1500,
                                message: '您输入的身份证号有误，请重新输入！',
                                type: 'warning'
                            })
                            return;
                        }else{
                            this.state = 2;
                        }
                    }
                }
                this.identitySubLoading = true;
                let _this = this;
                let param = {};
                let arr = [];
                arr.push(this.identityForm.userId)
                param['idArr'] = arr;
                param['state'] = this.state;
                param['identityName'] = this.identityForm.identityName;
                param['identityCode'] = this.identityForm.identityCode;
                param['type'] = this.isShow == 1?this.identityForm.type:0;
                if(this.regAgain) {
                    param['isRepeat']  = 1;
                }else{
                    param['isRepeat']  = 0;
                }
                postFormData(updateIdentityState,param).then(function(data){
                    let {code,msg} = data;
                    if(code == 200){
                        _this.$message({
                            showClose: true,
                            duration: 1000,
                            message: msg,
                            type: 'success'
                        });
                        _this.$emit('confirm');
                    }else{
                        _this.$message({
                            showClose: true,
                            duration: 1000,
                            message: msg,
                            type: 'warning'
                        })
                    }
                    // if(code == 30025 && _this.isFast) {
                    //     dialog.open({
                    //         title: '新认证用户的身份证号码已存在',
                    //         component: repeatDialog,
                    //         data: {
                    //             data: _this.identityForm,
                    //             width: '750px'
                    //         }
                    //     })
                    // }
                    _this.identitySubLoading = false;
                })
                    .catch(function(response){
                        _this.identitySubLoading = false;
                    })
            },

            getPlan(type, subType) {
                let param = {}
                param['uid'] = this.identityForm.uid;
                param['type'] = type;
                param['subType'] = subType;
                getFormData( getPlainInfo, param ).then((data)=>{
                    let {code, msg} = data;
                    if( code == 200 ) {
                        this.identityForm.identityCode = data.data.identityCode
                        this.identityForm.identityName = data.data.identityName
                        this.identityForm.imgF = data.data.identityImgF
                        this.identityForm.imgZ = data.data.identityImgZ
                    } else {
                        this.$message({
                            showClose: true,
                            duration: 1000,
                            message: msg,
                            type: 'warning'
                        })
                    }
                }).catch(()=>{

                })
            },


          appointAuth() {
            // console.log(this.identityForm)
            // Dialog.open({
            //   title: '指定用户【'+ this.identityForm.nickName +'】去认证？',
            //   component: AppointAuthDialog,
            //   data: {
            //     identity: this.identityForm.recheckAuthIdentity,
            //     zhima: this.identityForm.recheckAuthZhima,
            //     video: this.identityForm.recheckAuthVideo,
            //     identityState: this.identityForm.identityState,
            //     baiduState: this.identityForm.baiduState,
            //     zhimaCertifyState: this.identityForm.zhimaState,
            //     videoState: this.identityForm.authVideo?this.identityForm.authVideo.state:'',
            //     cancelVideoAuth: this.identityForm.cancelVideoAuth,
            //     cancelIdentityAuth: this.identityForm.cancelIdentityAuth,
            //     cancelZhimaAuth: this.identityForm.cancelZhimaAuth,
            //     userId: this.userId?this.userId:this.identityForm.userId,
            //     width: '400px'
            //   },
            //   confirm: (result) => {
            //     if(result.type == 1) {
            //       this.identityForm.cancelIdentityAuth = result.state;
            //     } else if(result.type == 2) {
            //       this.identityForm.cancelZhimaAuth = result.state;
            //     } else if(result.type == 3) {
            //       this.identityForm.cancelVideoAuth = result.state;
            //     } else {
            //       this.identityForm.recheckAuthIdentity = result.recheckAuthIdentity;
            //       this.identityForm.recheckAuthZhima = result.recheckAuthZhima;
            //       this.identityForm.recheckAuthVideo = result.recheckAuthVideo;
            //     }
            //   }
            // })

            this.$confirm('确定指定用户去人脸识别吗？').then(() => {
              let param = {};
              param['id'] = this.identityForm.userId;
              param['recheckAuthVideo'] = 0;
              param['recheckAuthZhima'] = 1;
              param['recheckAuthIdentity'] = 0;
              postFormData(updateResumeRecheckAuth, param).then((data) => {
                if(data.code == 200) {
                  this.$message({
                    showClose: true,
                    duration: 1000,
                    message: data.msg,
                    type: 'success'
                  })
                } else {
                  this.$message({
                    showClose: true,
                    duration: 1000,
                    message: data.msg,
                    type: 'warning'
                  })
                }
              })
                  .catch(() => {
                  })
            })
                .catch(() => {})

          },


        },
        mounted(){
            this.getPlan(12, 0)
          if(this.value.identityForm.identityState == 3) {
            this.checkList = [1,2]
          }
            if(this.value.identityForm.identityState == 4) {
              this.checkList = [1]
            }
            if(this.value.identityForm.identityState == 5) {
              this.checkList = [2]
            }
        }
    }
</script>

<style scoped>
.imgBox {
    position: relative;
}
.imgTitle {
    margin-left: 16px;
    background-color: #409eff;
    color: #ffffff;
    padding: 6px 12px;
    font-weight: bold;
    position: absolute;
    top: 0;
    z-index: 99;
    border-bottom-right-radius: 8px;
}
</style>
